"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var hooks_1 = require("./utils/hooks");
var XhrRequest_1 = require("./utils/XhrRequest");
var RequestProvider_1 = require("./RequestProvider");
function getInitialRequestState() {
    return {
        status: 'NOT_SEND',
        statusCode: 0,
        withLoader: false,
        progress: { loaded: 0, total: 1 },
    };
}
function getRequestParams(params, options, contextHeaders) {
    var url = options.url, method = options.method, headers = options.headers, query = options.query, body = options.body;
    if (url || (params && params.url)) {
        var paramsHeader = params ? params.headers : undefined;
        var requestHeaders = tslib_1.__assign({}, contextHeaders, headers, paramsHeader);
        return tslib_1.__assign({ url: url, method: method, headers: requestHeaders, query: query,
            body: body }, params);
    }
    throw new Error('url is missing in Request component');
}
function getRequestOptions(options) {
    var loaderDelay = options.loaderDelay, withProgress = options.withProgress, _a = options.abortOnUnmount, abortOnUnmount = _a === void 0 ? true : _a;
    return {
        loaderDelay: loaderDelay,
        withProgress: withProgress,
        abortOnUnmount: abortOnUnmount,
    };
}
function getRequest(params, options, contextHeaders) {
    var requestParams = getRequestParams(params, options, contextHeaders);
    var requestOptions = getRequestOptions(options);
    var request = new XhrRequest_1.default(requestParams, requestOptions);
    return request;
}
function useRequest(options) {
    var contextHeaders = react_1.useContext(RequestProvider_1.RequestContext);
    var requestRef = react_1.useRef(null);
    var _a = react_1.useState(function () { return getInitialRequestState(); }), requestState = _a[0], setRequestState = _a[1];
    var memoizedOptions = hooks_1.useShallowEqualsMemo(function () { return options; }, [options]);
    var onSuccess = memoizedOptions.onSuccess, onError = memoizedOptions.onError;
    var updateRequestState = react_1.useCallback(function (requestState) {
        var request = requestRef.current;
        if (onSuccess && requestState.status === 'SUCCESS') {
            onSuccess(requestState.data, request.params);
        }
        else if (onError && requestState.status === 'FAILED') {
            onError(requestState.error, requestState.statusCode, request.params);
        }
        setRequestState(requestState);
    }, []);
    var fetch = react_1.useCallback(function (params) {
        if (params === void 0) { params = {}; }
        if (requestRef.current) {
            requestRef.current.removeStateListener(updateRequestState);
        }
        var newRequest = getRequest(params, memoizedOptions, contextHeaders);
        newRequest.addStateListener(updateRequestState);
        newRequest.fetch();
        requestRef.current = newRequest;
    }, [memoizedOptions, contextHeaders]);
    hooks_1.useUnmount(function () {
        if (requestRef.current) {
            var onSuccess_1 = options.onSuccess, onError_1 = options.onError, _a = options.abortOnUnmount, abortOnUnmount = _a === void 0 ? true : _a;
            if (requestRef.current.state.status === 'LOADING' && !abortOnUnmount) {
                if (onSuccess_1) {
                    requestRef.current.addSuccessCallbacks(onSuccess_1);
                }
                if (onError_1) {
                    requestRef.current.addErrorCallbacks(onError_1);
                }
            }
            requestRef.current.removeStateListener(updateRequestState);
        }
    });
    return tslib_1.__assign({}, requestState, { fetch: fetch });
}
exports.default = useRequest;
